var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22438_31379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.34279 6.83067L7.67412 3.65134C7.85596 3.40301 7.96549 3.10918 7.99056 2.80242C8.01562 2.49566 7.95526 2.18795 7.81615 1.9134C7.67705 1.63884 7.46463 1.40817 7.20245 1.24695C6.94027 1.08573 6.63857 1.00025 6.33079 1L1.66579 1C1.3577 0.999523 1.05553 1.08455 0.792904 1.24562C0.530276 1.40669 0.317499 1.63748 0.178257 1.9123C0.0390139 2.18712 -0.0212307 2.4952 0.00422764 2.80223C0.029686 3.10926 0.139849 3.4032 0.322455 3.65134L2.65379 6.83067C2.80861 7.04163 3.01092 7.21317 3.24435 7.33141C3.47779 7.44965 3.73578 7.51126 3.99746 7.51126C4.25913 7.51126 4.51712 7.44965 4.75056 7.33141C4.98399 7.21317 5.18631 7.04163 5.34112 6.83067H5.34279Z",
    fill: "#378861"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22438_31379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "matrix(0 1 -1 0 8 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallArrow);
export default __webpack_public_path__ + "static/media/small-arrow.0c20dd8ca0f31aa0e15ecd640d8da8a7.svg";
export { ForwardRef as ReactComponent };